<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <MerchantMultiselect :multiple="true" v-model="merchantsFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <StoreMultiselect :multiple="true" v-model="storesFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}" is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                      <template v-slot="{ inputValue, togglePopover, inputEvents }">
                        <input
                          class="form-control form-control-sm"
                          :placeholder="helper.trans('labels.from_date')"
                          :value="inputValue"
                          @focus="togglePopover"
                          @change="inputEvents.change"
                        />
                      </template>
                    </DatePicker>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}" is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                      <template v-slot="{ inputValue, togglePopover, inputEvents }">
                        <input
                          class="form-control form-control-sm"
                          :placeholder="helper.trans('labels.to_date')"
                          :value="inputValue"
                          @focus="togglePopover"
                          @change="inputEvents.change"
                        />
                      </template>
                    </DatePicker>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <TraderMultiselect @update:model-value="onTraderListUpdate" :multiple="true" v-model="tradersFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <Multiselect
                      id="provider-requests-methods"
                      class="multiselect-sm"
                      v-model="requestDTO.methods"
                      :options="store.getters['currencyMethods/methods']()"
                      :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                      :multiple="true"
                      select-label="Select"
                      :placeholder="helper.trans('labels.payment_methods')"
                    >
                      <template #option="props">
                        <div class="d-flex flex-row align-items-center gap-2">
                          <PayMethodIcon icon-class="icon" :method="props.option" />
                          <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                        </div>
                      </template>
                    </Multiselect>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <Multiselect
                      id="provider-requests-options"
                      class="multiselect-sm"
                      v-model="requestDTO.options"
                      :options="store.getters['currencyMethods/options']()"
                      :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                      :multiple="true"
                      select-label="Select"
                      :placeholder="helper.trans('labels.payment_options')"
                    />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <Multiselect
                      id="provider-requests-types"
                      class="multiselect-sm"
                      v-model="requestDTO.types"
                      :options="Object.values(Direction)"
                      :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                      :multiple="true"
                      select-label="Select"
                      :placeholder="helper.trans('labels.type')"
                    />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <DevicesMultiselect ref="deviceMultiselect" :multiple="true" :trader-ids="tradersFilter.map((item) => item.id)" v-model="devicesFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <TeamLeadMultiselect :multiple="false" v-model="teamLeadFilter" />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <Multiselect
                      id="provider-requests-currency"
                      class="multiselect-sm multiselect-capitalize"
                      v-model="requestDTO.currency"
                      :options="store.getters['currencyMethods/currencies']"
                      :custom-label="(opt) => opt"
                      :multiple="false"
                      select-label="Select"
                      :placeholder="helper.trans('labels.currency')"
                    />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountFrom" class="form-control form-control-sm" :placeholder="helper.trans('labels.from_sum')" />
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountTo" class="form-control form-control-sm" :placeholder="helper.trans('labels.to_sum')" />
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end">
                    <button type="button" @click.prevent="applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col text-end">
                  <button type="button" @click.prevent="downloadReport()" class="btn btn-link btn-sm m-0 p-0 text-capitalize-first">
                    <i class="fa-solid fa-download"></i> {{ helper.trans('labels.download_report') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <table class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
                <tr class="bg-light">
                  <th class="text-capitalize-first" rowspan="2">{{ helper.trans('statistic.providerRequests.provider') }}</th>
                  <th class="text-capitalize-first text-center" colspan="2">{{ helper.trans('statistic.providerRequests.total') }}</th>
                  <th class="text-capitalize-first text-center" colspan="2">{{ helper.trans('statistic.providerRequests.issued') }}</th>
                  <th class="text-capitalize-first text-center" colspan="2">{{ helper.trans('statistic.providerRequests.paid') }}</th>
                  <th class="text-capitalize-first text-center" colspan="2">{{ helper.trans('statistic.providerRequests.not_issued') }}</th>
                  <th class="text-capitalize-first" rowspan="2">{{ helper.trans('labels.currency') }}</th>
                </tr>
                <tr class="bg-light">
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.count') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.sum') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.count') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.sum') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.count') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.sum') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.count') }}</th>
                  <th class="text-capitalize-first text-center">{{ helper.trans('statistic.providerRequests.sum') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="item.provider?.id ?? index">
                  <td>{{ item.provider?.name ?? '' }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.totalCount ?? 0) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.totalSum ?? 0, 2) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.issuedCount ?? 0) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.issuedSum ?? 0, 2) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.paidCount ?? 0) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.paidSum ?? 0, 2) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.notIssuedCount ?? 0) }}</td>
                  <td class="text-end">{{ numberFormatter.formatNumber(item.notIssuedSum ?? 0, 2) }}</td>
                  <td>{{ item.currency ?? '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import { defineComponent, onMounted, reactive, ref, toRefs } from "vue";
import { dateHelper } from "@/service/DateHelper";
import { numberFormatter } from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import { useStore } from "vuex";
import { debounce, helper } from "@/service/CommonHelper";
import { useNotification } from "@kyvg/vue3-notification";
import { DatePicker } from "v-calendar";
import Multiselect from "vue-multiselect";
import moment from "moment";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import { Direction } from "@/models/enum/Direction";
import MerchantDTO from "@/models/MerchantDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import TraderDTO from "@/models/TraderDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import UserDTO from "@/models/UserDTO";
import ProviderRequestsSummaryItemDTO from "@/models/ProviderRequestsSummaryItemDTO";

const api = new APIClient();
const notification = useNotification();

function defaultRequestDTO() {
  return {
    fromDate: moment().format('YYYY-MM-DD 00:00:00'),
    toDate: null,
    methods: [] as string[],
    options: [] as string[],
    types: [] as string[],
    currency: null as string | null,
    amountFrom: null as string | null,
    amountTo: null as string | null,
  };
}

export default defineComponent({
  components: {
    LoaderWrapper,
    DatePicker,
    Multiselect,
    MerchantMultiselect,
    StoreMultiselect,
    TraderMultiselect,
    TrafficGroupMultiselect,
    TeamLeadMultiselect,
    DevicesMultiselect,
    PayMethodIcon,
  },
  setup() {
    const store = useStore();
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null);
    const deviceMultiselect = ref<InstanceType<typeof DevicesMultiselect> | null>(null);

    const state = reactive({
      merchantsFilter: [] as MerchantDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      tradersFilter: [] as TraderDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      devicesFilter: [] as TraderDeviceDTO[],
      teamLeadFilter: null as UserDTO | null,
      items: [] as ProviderRequestsSummaryItemDTO[],
      requestDTO: defaultRequestDTO(),
    });

    const onTraderListUpdate = debounce(() => {
      deviceMultiselect.value?.search("");
    }, 1000);

    const buildParams = () => {
      const storeIds = state.storesFilter.map((s) => s.id);
      const merchantIds = state.merchantsFilter.map((m) => m.id);
      const traderIds = state.tradersFilter.map((t) => t.id);
      const trafficGroupsIds = state.trafficGroupsFilter.map((g) => g.id);
      const deviceIds = state.devicesFilter.map((d) => d.id);
      const params: Record<string, unknown> = {
        fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
        toDate: dateHelper.toUTC(state.requestDTO.toDate),
      };
      if (storeIds.length) params.storeIds = storeIds;
      if (merchantIds.length) params.merchantIds = merchantIds;
      if (traderIds.length) params.traderIds = traderIds;
      if (trafficGroupsIds.length) params.trafficGroupsIds = trafficGroupsIds;
      if (deviceIds.length) params.deviceIds = deviceIds;
      if (state.teamLeadFilter?.id != null) params.teamLeadId = state.teamLeadFilter.id;
      if (state.requestDTO.methods?.length) params.methods = state.requestDTO.methods;
      if (state.requestDTO.options?.length) params.options = state.requestDTO.options;
      if (state.requestDTO.types?.length) params.types = state.requestDTO.types;
      if (state.requestDTO.currency) params.currency = state.requestDTO.currency;
      if (state.requestDTO.amountFrom) params.amountFrom = state.requestDTO.amountFrom;
      if (state.requestDTO.amountTo) params.amountTo = state.requestDTO.amountTo;
      return params;
    };

    const load = async () => {
      loader.value?.show();
      try {
        state.items = await api.statisticProviderRequestsSummary(buildParams());
      } catch (error) {
        notification.notify({
          type: "error",
          title: helper.trans("labels.error"),
          text: error instanceof Error ? error.message : String(error),
        });
      } finally {
        loader.value?.hide();
      }
    };

    const applyFilters = () => {
      load();
    };

    const clearFilters = () => {
      state.merchantsFilter = [];
      state.storesFilter = [];
      state.tradersFilter = [];
      state.trafficGroupsFilter = [];
      state.devicesFilter = [];
      state.teamLeadFilter = null;
      state.requestDTO = defaultRequestDTO();
      load();
    };

    const downloadReport = async () => {
      loader.value?.show();
      try {
        const data = await api.export("provider_requests_stat", buildParams());
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        notification.notify({
          type: "error",
          title: helper.trans("labels.error"),
          text: error instanceof Error ? error.message : String(error),
        });
      } finally {
        loader.value?.hide();
      }
    };

    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      store,
      Direction,
      applyFilters,
      clearFilters,
      downloadReport,
      onTraderListUpdate,
      deviceMultiselect,
    };
  },
});
</script>
